import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Modal from '../modal';
import { ModalAction, SaleAction } from '../../store/actions';

class EditCustom extends PureComponent {
  static propTypes = {
    closeModal: PropTypes.func,
    editCustomSale: PropTypes.func,
    sale: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    saleId: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = this.getInitialState(props.sale);
    this.onChange = this.onChange.bind(this);
  }

  componentDidUpdate(props, _state, _snapshot) {
    if (JSON.stringify(props.sale) !== JSON.stringify(this.props.sale)) {
      this.setState({ ...this.getInitialState(this.props.sale) });
    }
  }

  getInitialState(sale) {
    return {
      custom_id: sale?.custom_id || sale?.id || '',
      custom_price: sale?.custom_price || sale?.price || '',
      custom_sold_at: sale?.custom_sold_at || sale?.sold_at || '',
    };
  }

  onChange(event) {
    const { target: { name, value } = {} } = event;
    this.setState({ [name]: value });
  }

  onClear(_) {
    this.setState(this.getInitialState());
  }

  onSubmit(event) {
    event.preventDefault();
    if (!confirm('Are you sure?')) {
      return;
    }
    this.props.editCustomSale(this.props.saleId, this.state);
  }

  render() {
    return (
      <Modal
        close={() => this.props.closeModal()}
        open={this.props.isOpen}
        size="lg"
        title="Custom Edit Sale"
      >
        <form onSubmit={this.onSubmit.bind(this)}>
          <div className="form-row">
            <div className="form-group col">
              <label htmlFor="custom_id">Custom ID</label>
              <input
                className="form-control"
                id="custom_id"
                name="custom_id"
                onChange={this.onChange}
                placeholder="Custom ID"
                type="number"
                value={this.state.custom_id}
              />
            </div>
            <div className="form-group col">
              <label htmlFor="custom_price">Custom Price</label>
              <input
                className="form-control"
                id="custom_price"
                name="custom_price"
                onChange={this.onChange}
                placeholder="Custom Price"
                type="number"
                value={this.state.custom_price}
              />
            </div>
            <div className="form-group col">
              <label htmlFor="custom_sold_at">Custom Sold At</label>
              <input
                className="form-control"
                id="custom_sold_at"
                name="custom_sold_at"
                onChange={this.onChange}
                placeholder="Custom Sold At"
                type="date"
                value={this.state.custom_sold_at}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col">
              <button className="btn btn-primary" type="submit">
                Save
              </button>
            </div>
            <div className="form-group col">
              <button
                className="btn btn-warning float-right"
                onClick={this.onClear.bind(this)}
                type="reset"
              >
                Clear
              </button>
            </div>
          </div>
        </form>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isOpen: !!state?.modal?.EditCustomSale,
  sale: state?.modal?.EditCustomSale,
  saleId: Number(state?.modal?.EditCustomSale?.id),
});

const mapDispatchToProps = dispatch => ({
  closeModal: () =>
    dispatch(ModalAction.closeModal({ name: 'EditCustomSale' })),
  editCustomSale: (id, data) => dispatch(SaleAction.editCustomSale(id, data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditCustom);
